
define('modules/application/widgets/audioVideoConsumptionIndicator',[
  "app",

  // Libs
  "backbone",

  //Classes
  "../header",

  "./consumptionIndicator"

],

function(app, Backbone, Header, consumptionIndicator) {

  var audiovideoConsumptionIndicatorModel= consumptionIndicator.Model.extend({

    defaults : {
      totalSupplyCurrent      : 0,
      totalCurrentConsumption : 0,
      percentageOfTotalCurrentConsumption : 0
    },

    initialize : function() {
      var that = this;
      BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", []);

      /*Binding events*/
      //this.bind("change:conversationTotalSupplyCurrent",             this.recalculatePercentages, this);
      //this.bind("change:conversationTotalCurrentConsumption",        this.recalculatePercentages, this);
      //this.bind("change:soundDiffusionTotalSupplyCurrent",           this.recalculatePercentages, this);
      //this.bind("change:soundDiffusionTotalSupplyCurrent",           this.recalculatePercentages, this);

      window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested",         this.resetCurrents);
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",           this.resetCurrents, this);

      /*Animation Test*/
      //self.setInterval(function(){that.set("totalCurrentConsumption", Math.floor((Math.random()*125)+1));},1000);
    },

    addConversationSupplyCurrent                           : function(supplyCurrentToAdd)      {
      this.set("conversationTotalSupplyCurrent",        this.get("conversationTotalSupplyCurrent")+Math.abs(supplyCurrentToAdd));
      this.recalculatePercentages();
      //console.log("Aggiunto supply", supplyCurrentToAdd);
    },

    addConversationCurrentConsumption                      : function(currentConsumptionToAdd) {
      this.set("conversationTotalCurrentConsumption",   this.get("conversationTotalCurrentConsumption")+Math.abs(currentConsumptionToAdd));
      this.recalculatePercentages();
      //console.log("Aggiunto consumption", currentConsumptionToAdd);
    },

    addSoundDiffusionSupplyCurrent                         : function(supplyCurrentToAdd)      {
      this.set("soundDiffusionTotalSupplyCurrent",      this.get("soundDiffusionTotalSupplyCurrent")+Math.abs(supplyCurrentToAdd));
      this.recalculatePercentages();
      //console.log("Aggiunto supply", supplyCurrentToAdd);
    },

    addSoundDiffusionCurrentConsumption                    : function(currentConsumptionToAdd) {
      this.set("soundDiffusionTotalCurrentConsumption", this.get("soundDiffusionTotalCurrentConsumption")+Math.abs(currentConsumptionToAdd));
      this.recalculatePercentages();
      //console.log("Aggiunto consumption", currentConsumptionToAdd);
    },

    resetCurrents                              : function() {
      this.set("conversationTotalSupplyCurrent",         0);
      this.set("conversationTotalCurrentConsumption",    0);
      BticinoS4B.Instances.Models.ApplicationModel.set("conversationMaxExtraConsumption",   []);

      this.set("soundDiffusionTotalSupplyCurrent",       0);
      this.set("soundDiffusionTotalCurrentConsumption",  0);
      BticinoS4B.Instances.Models.ApplicationModel.set("soundDiffusionMaxExtraConsumption", []);
      //console.log('CORRENTI AZZERATE');
      this.recalculatePercentages();

    },

    recalculatePercentages                     : function() {
      var conversationTotalSupplyCurrent              = (this.get("conversationTotalSupplyCurrent")!==0)   ? this.get("conversationTotalSupplyCurrent")   : 1,
          conversationTotalCurrentConsumption         = this.get("conversationTotalCurrentConsumption"),
          soundDiffusionTotalSupplyCurrent            = (this.get("soundDiffusionTotalSupplyCurrent")!==0) ? this.get("soundDiffusionTotalSupplyCurrent") : 1,
          soundDiffusionTotalCurrentConsumption       = this.get("soundDiffusionTotalCurrentConsumption");

      var conversationMaxExtraConsumption             = BticinoS4B.Instances.Models.ApplicationModel.get("conversationMaxExtraConsumption");
      var soundDiffusionMaxExtraConsumption           = BticinoS4B.Instances.Models.ApplicationModel.get("soundDiffusionMaxExtraConsumption");

      for (var i in conversationMaxExtraConsumption)
        if (typeof conversationMaxExtraConsumption[i] !== 'function')
          conversationTotalCurrentConsumption   += conversationMaxExtraConsumption[i];

      for (var j in soundDiffusionMaxExtraConsumption)
        if (typeof soundDiffusionMaxExtraConsumption[j] !== 'function')
          soundDiffusionTotalCurrentConsumption += soundDiffusionMaxExtraConsumption[j];

      var conversationPercentageOfTotalSupplyCurrent  = conversationTotalCurrentConsumption   * 100/conversationTotalSupplyCurrent,
          soundDiffusionPercentageOfTotalSupplyCurrent= soundDiffusionTotalCurrentConsumption * 100/soundDiffusionTotalSupplyCurrent;

      var conversationConsumptionInmA                 = conversationTotalCurrentConsumption - conversationTotalSupplyCurrent;
      var soundDiffusionConsumptionInmA               = soundDiffusionTotalCurrentConsumption - soundDiffusionTotalSupplyCurrent;

      var totalConsumptionInmA                        = (conversationConsumptionInmA>=soundDiffusionConsumptionInmA) ?
                                                        conversationConsumptionInmA : soundDiffusionConsumptionInmA;

      var percentageOfTotalCurrentConsumption         = (conversationPercentageOfTotalSupplyCurrent>=soundDiffusionPercentageOfTotalSupplyCurrent) ?
                                                        conversationPercentageOfTotalSupplyCurrent : soundDiffusionPercentageOfTotalSupplyCurrent;

      //console.log((conversationPercentageOfTotalSupplyCurrent>=soundDiffusionPercentageOfTotalSupplyCurrent) ? "conversation" : "soundDiffusion");
      //console.log(percentageOfTotalCurrentConsumption);
      this.set("totalConsumptionInmA",                totalConsumptionInmA);
      //console.log(totalConsumptionInmA);
      this.set("percentageOfTotalCurrentConsumption", percentageOfTotalCurrentConsumption);
    }

  });

  var audiovideoConsumptionIndicatorView = consumptionIndicator.View.extend({
    className  : "consumptionIndicator",
    template   : "application/widgets/consumptionIndicator",
    initialize : function() {
      consumptionIndicator.View.prototype.initialize.apply(this);
      this.fullWidth = 125;
    }
  });

  var audiovideoConsumptionIndicator = {
    Model: audiovideoConsumptionIndicatorModel,
    View : audiovideoConsumptionIndicatorView
  };

  return audiovideoConsumptionIndicator;

});